import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { compareEntities } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { ModulePage } from 'module/page/module-page';
import { ModulePageRepositoryPort } from 'module/page/port/module-page-repository.port';

import { CacheObservable } from '../../../app-decorators';
import { ModulePageState, ModulePageStore } from './module-page.types';

@Injectable()
export class ModulePageRepositoryAdapter
	extends QueryEntity<ModulePageState>
	implements ModulePageRepositoryPort
{
	constructor(protected store: ModulePageStore) {
		super(store);
	}

	@CacheObservable()
	public observePagesByIds(pagesId: string[]): Observable<ModulePage[]> {
		return this.selectAll({
			filterBy: (entity) => pagesId.includes(entity.id),
			sortByOrder: Order.ASC,
			sortBy: 'position',
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveModulePages(entities: ModulePage[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
